import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class TourServiceService {
  siteUrl: any = ''
  constructor(private crudService: CrudService) {
    this.siteUrl = this.crudService.TourFileUrl;
  }

  GetTourMasterDetails(): Observable<any> {
    return this.crudService.get<any>('Tour/GetTourMasterDetails');
  }
  SaveTourHeader(TourData: any): Observable<any> {
    // debugger;
    return this.crudService.post<any>('Tour/SaveTourDetails', TourData);
  }

  ValidateTourDetails(TourData: any): Observable<any> {
    // debugger;
    return this.crudService.post<any>('Tour/ValidateTourDetails', TourData);
  }

  SaveTourDocument(TourData: any): Observable<any> {
    return this.crudService.post<any>('Tour/UploadDocuments', TourData);
  }

  getUploadedData(TourId: any): Observable<any> {
    return this.crudService.get<any>(`Tour/getUploadedFiles?TourId=` + TourId);
  }

  // getTourDetailsByRecordID(RecordNo: number): Observable<any> {
  //   return this.crudService.get<any>('Tour/GetTourDetailsById?Id=' + RecordNo);
  // }

  getTourDetailsByRecordID(RecordNo: any): Observable<any> {
    return this.crudService.get<any>('Tour/GetTourDetailsById?Id=' + RecordNo);
  }

  deleteRecord(recordId: number, userId: any, flag: string) {
    return this.crudService.get<any>('Tour/deleteTourDetails?recordId=' + recordId + '&userId=' + userId + '&flag=' + flag);
  }

  DeleteTourById(recordId: any, userId: string): Observable<any> {
    return this.crudService.get<any>('Tour/DeleteTourById?Id=' + recordId + '&UserId=' + encodeURIComponent(userId || ''));
  }

  deleteUploadedFile(TourId: any, fileName: any, fileType: string, docId) {
    return this.crudService.get<any>('Tour/deleteUploadedFile?TourId=' + TourId + '&fileName=' + fileName + '&fileType=' + fileType + '&docId=' + docId);
  }

  getTourList(UserId: string): Observable<any> {
    return this.crudService.get<any>('Tour/GetAllTourDetails?UserId=' + UserId);
  }

  getTourStatusList(
    UserId: string,
    pgNo: number,
    maxRows: number,
    fromDate?: string,
    toDate?: string,
    search?: string
  ): Observable<any> {
    let url = 'Tour/GetTourStatusList?UserId=' + encodeURIComponent(UserId)
      + '&pgNo=' + pgNo
      + '&maxRows=' + maxRows;
    if (fromDate) {
      url += '&fromDate=' + encodeURIComponent(fromDate);
    }
    if (toDate) {
      url += '&toDate=' + encodeURIComponent(toDate);
    }
    if (search) {
      url += '&search=' + encodeURIComponent(search);
    }
    return this.crudService.get<any>(url);
  }



  ReInitiateTour(TourData: any): Observable<any> {
    return this.crudService.post<any>('Tour/ReInitiateTour', TourData);
  }

  UpdatelistStatus(TourData: any): Observable<any> {
    return this.crudService.post<any>('Tour/UpdateListStatus', TourData);
  }

  UpdateStatus(TourData: any): Observable<any> {
    return this.crudService.post<any>('Tour/UpdateStatus', TourData);
  }

  GetReportingHeadApprovalDetails(UserId: string): Observable<any> {
    return this.crudService.get<any>('Tour/GetReportingHeadApprovalDetails?UserId=' + UserId);
  }

  getDaDetail(band: string): Observable<any> {
    return this.crudService.get<any>('Tour/GetDaDetail?band=' + band);
  }

  getTourERPReport(): Observable<any> {
    return this.crudService.get('Tour/TourERPReport');
  }
  getTourSummaryReport(): Observable<any> {
    return this.crudService.get('Tour/TourSummaryReport');
  }

}
